import { ConfigurationTypes } from '../../vendor_core/core/src/const/ConfigurationTypes';
import IRelaxServerConfig from '../../vendor_core/core/src/managers/contracts/configurations/IRelaxServerConfig';

class ServerConfig implements IRelaxServerConfig {
    type: ConfigurationTypes = ConfigurationTypes.RELAX_SERVER;
    _partnerId?: number = 1;
    _gameId: string = "starpops";
    _clientconfigurl: string = "https://dev-casino-client.api.relaxg.net/capi/1.0/casino/games/getclientconfig";

    get partnerId(): number {
        return this._partnerId
    }
    get clientconfigurl(): string {
        return this._clientconfigurl
    }
    get gameId(): string {
        return this._gameId
    }
    parseParams(data: any): void {
        data?.gameid ? this._gameId = data.gameid : null;
        data?.partnerid ? this._partnerId = data.partnerid : null;
        data?.clientconfigurl ? this._clientconfigurl = data.clientconfigurl : null;
        if (data?.configurl) {
            data?.configurl.includes("/ios") ? this._clientconfigurl = data.configurl : this._clientconfigurl = `${data.configurl}/ios`
        }
    }
}

export default new ServerConfig()
